const account = {
    title: String("User profile"),
    terrains: String("Terrains"),
    modules: String("Modules"),
    myDataTitle: String("My user profile"),
    aboutMeTitle: String("About me"),
    usernameLabel: String("Username"),
    nifLabel: String("DNI/NIF"),
    nifPlaceholder: String("12345678A"),
    emailLabel: String("Email"),
    emailPlaceholder: String("Example&#64example.com"),
    nameLabel: String("Name"),
    namePlaceholder: String("Name..."),
    lastName1Label: String("Surname"),
    lastName1Placeholder: String("Surname..."),
    lastName2Label: String("Second surname"),
    lastName2Placeholder: String("Second surname..."),
    phoneLabel: String("Telephone"),
    phonePlaceholder: String("123456789"),
    selectLanguage: String("Select the language"),
    contactInfoTitle: String("Contact information"),
    addressSearchBarLabel: String("Search address"),
    accountGoogleAskAddressPlaceholder: String("Example street"),
    addressLabel: String("Address"),
    addressPlaceholder: String("Example street"),
    numberLabel: String("Number"),
    numberPlaceholder: String("0"),
    cityLabel: String("City"),
    cityPlaceholder: String("City..."),
    provinceLabel: String("Province"),
    provincePlaceholder: String("Province..."),
    zipLabel: String("Postal Code"),
    zipPlaceholder: String("12345"),
    regionLabel: String("Region"),
    regionPlaceholder: String("Region..."),
    countryLabel: String("Country"),
    countryPlaceholder: String("Country..."),
    updateButton: String("Update"),
    restoreButton: String("Restore"),
    errorFieldRequired: String("This field is required"),
    errorFieldEmail: String("Invalid email."),
    errorInvalidField: String("Invalid field. This field can only contain letters, hyphen (-) and spaces."),
    errorInvalidNif: String("Invalid format. This field must contain 8 numbers plus a letter. 01234567A"),
    errorFieldNumeric: String("This field can only contain numbers"),
    errorInvalidLength: String("Number of minimum characters: {length}"),
    errorsModalTitle: String("Update error"),
    errorsModalBodyTitle: String("There has been some error during update"),
    errorsModalCloseButton: String("Close"),
};

export default account;
